<template>
    <el-dialog :visible="openDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="!processing"
               :show-close="!processing"
               @close="$emit('update:openDialog', false)"
               :title="(eraseModeOn ? 'Remove' : 'Add') + ' Zip Groups'">

        <el-form>
            <el-form-item>
                <el-input type="textarea"
                          :disabled="processing"
                          :rows="5"
                          v-model="zipGroups"/>
                <p class="help-block">Input comma separated list of 3 numbers digits (ex. 382, 999). System will automatically append numbers 00 - 99 and make zip codes from them.</p>
            </el-form-item>
        </el-form>

        <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false">
            {{ errorMessage }}
        </el-alert>

        <span slot="footer" class="dialog-footer">
            <el-button :disabled="processing" @click="$emit('update:openDialog', false)">Cancel</el-button>
            <el-button :disabled="processing" :type="eraseModeOn ? 'danger' : 'success'" @click="process">
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> {{ eraseModeOn ? 'Remove' : 'Add' }}
            </el-button>
        </span>

    </el-dialog>
</template>

<script>
    export default {
        props: {
            areaId: { type: Number, required: true },
            openDialog: { type: Boolean, required: true },
            eraseModeOn: { type: Boolean, required: true },
            mapUrl: { type: Function, required: true }
        },
        data() {
            return {
                zipGroups: '',
                processing: false,
                errorMessage: null,
            };
        },
        methods: {
            process() {
                this.processing = true;
                this.errorMessage = null;

                axios.post(this.url(`admin/area/add-zip-group`), {
                    data: this.zipGroups,
                    area_id: this.areaId,
                    is_exclusion: this.eraseModeOn,
                })
                     .then(response => {
                         this.zipGroups = '';
                         this.$emit('process');
                         this.$emit('update:openDialog', false);
                     })
                     .finally(() => { this.processing = false; });
            },
        },
    };
</script>
